import React, {useReducer, useEffect} from 'react'
import axios from 'axios'

const initialState = {
  loading: true,
  errors: [],
  error: '',

  reportTitle: "Programs Stats",
  reportData: [],

}

const reducer = (state, action) => {
     switch(action.type) {
         case 'FETCH_SUCCESS':
          console.log("4447-10031 - action.payload.data = " );
          console.log( action.payload.data);
          return {
            loading: false,
            error: '',
            reportTitle: "Programs Stats",

                                  // reportData: dataEntry,
            reportData: (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) ? action.payload.data : [] ,
          }
         case 'FETCH_ERROR':
            return {
              loading: false,
              error: 'ERROR: ProgramsCounts - Something went wrong.....',
              // errors: [action.payload.response],

              reportData: [],

            }
        default:
            return state
     }
}

function ProgramCounts() {
  const [state, dispatch] = useReducer(reducer, initialState)

  useEffect(() => {
    // const  PROGRAMS_COUNTS = 'reports/programscount/loginid'
    const  PROGRAMS_COUNTS_2 = 'reports/programscount'

      // const postURL = `https://jsonplaceholder.typicode.com/posts/1`
      const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + PROGRAMS_COUNTS_2
      axios
          // .get(postURL)
          .get(JSONURL)
          .then(response => {
              dispatch({type: 'FETCH_SUCCESS', payload: response.data})
          })
          .catch(err => {
              dispatch({type: 'FETCH_ERROR'})
          })

      // return () => {
      //     cleanup
        // };
  }, [])

  return (
    <div>
      <p class="reporttitle">{state.loading ? 'Loading...' : state.reportTitle}</p>

      <table>
        
        <thead>
          <tr>
            <th class="bodyheader">SERVICE</th>
            {/* <th class="service">SERVICE</th> */}
            <th class="desc">DESCRIPTION</th>
          </tr>
        </thead>

        <tbody>

          {state.reportData.map((data) => (
            <>
            {/* <React.Fragment key={data.value} > */}
              <tr>
                {/* <td class="bodydata">Description</td> */}
                <td class="bodydata">
                  <b>
                    {data.description}
                  </b>
                </td>
                <td class="bodydata"></td>
              </tr>
              <tr>
                <td class="service">Referrals</td>
                <td class="bodydata">{data.referrals}</td>
              </tr>
              <tr>
                <td class="service">Clients</td>
                <td class="bodydata">{data.clients}</td>
              </tr>
              <tr>
                <td class="service">Post Discharges</td>
                <td class="bodydata">{data.postdischarges}</td>
              </tr>
              <tr>
                <td class="service">Archived Referrals</td>
                <td class="bodydata">{data.archivedreferrals}</td>
              </tr>
              <tr>
                <td class="service">Archived Clients</td>
                <td class="bodydata">{data.archivedclients}</td>
              </tr>
              <tr>
                <td class="service">Archived Post Discharges</td>
                <td class="bodydata">{data.archivedpostdischarges}</td>
              </tr>
            {/* </React.Fragment> */}
            </>

          ))}
          


          {/* Totals */}
          <tr>
            <td colspan="0">SUBTOTAL</td>
            <td class="total">$5,200.00</td>
          </tr>
          <tr>
            <td colspan="0">TAX 25%</td>
            <td class="total">$1,300.00</td>
          </tr>
          <tr>
            <td colspan="0" class="grand total">GRAND TOTAL</td>
            <td class="grand total">$6,500.00</td>
          </tr>

{/*           
          <tr>
            <td colspan="3">SUBTOTAL</td>
            <td class="total">$5,200.00</td>
          </tr>
          <tr>
            <td colspan="3">TAX 25%</td>
            <td class="total">$1,300.00</td>
          </tr>
          <tr>
            <td colspan="3" class="grand total">GRAND TOTAL</td>
            <td class="grand total">$6,500.00</td>
          </tr>
 */}

        </tbody>
      </table>

      <hr />
        {state.error ? state.error : null}

    </div>
  )
}
export default ProgramCounts